import { JSX } from "react";

interface MegaMenuHeaderProps {
  title: string;
}

export default function MegaMenu({ title }: MegaMenuHeaderProps): JSX.Element {
  return (
    <div className="menu-header"><h3>{title}</h3></div>
  );
}
